module.exports = __webpack_public_path__ + "static/media/Unnakkaya.3601c050.jpg";